import React, {Component} from 'react'
import {FormattedMessage, FormattedDate, FormattedNumber, FormattedTime} from 'react-intl'
import LabelUnitOfMeasure from '../../../common/unit-of-measure/label.component.jsx'

class WorkOrderReceiptItems extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            receipt: this.props.value || null,
            isPdf: this.props.isPdf || false,
            taxAmount: '0',
            totalAmount: '0',
            totalAmountWithoutTax: '0',
        }
        if (this.state.receipt) {
            this.state.taxAmount = this.state.receipt.workOrder.taxAmount
            this.state.totalAmountWithoutTax = this.state.receipt.workOrder.totalAmountWithoutTax
            this.state.totalAmount = this.state.receipt.workOrder.totalAmount
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.receipt) {
            this.setState({
                receipt: nextProps.value || null,
                totalAmountWithoutTax: nextProps.value.workOrder.totalAmountWithoutTax,
                taxAmount:  nextProps.value.workOrder.taxAmount,
                totalAmount: nextProps.value.workOrder.totalAmount,
                isPdf: nextProps.isPdf || false,
            })
        }
    }

    renderItems() {
        return this.state.receipt.workOrder.items.map(item => {
            let price = <FormattedNumber
                style="currency"
                currency={this.state.receipt.workOrder.currency}
                value={item.subtotalAmount}
            />

            const assemblyDetails = []
            if (item.product.isAssembly) {
                for (let field in item.product.assemblyDetails) {
                    assemblyDetails.push(
                        <span key={field}>
                            <strong>{field}:</strong> {item.product.assemblyDetails[field]}<br/>
                        </span>
                    )
                }
            }
            const measure = <span className="mr-1">
                <small>
                    <LabelUnitOfMeasure
                        unit={item.unitOfMeasure}
                        value={item.measure}
                        format='short'
                    />
                    &nbsp;
                    <strong>×</strong>
                </small>
            </span>
            const title = <h5 className="mt-0 mb-1 pb-0" style={{border: 'none'}}>{item.product.title}</h5>
            const shortDescription = <div>
                {item.product.shortDescription.split('\n').map((item, key) => {
                    return <span key={key}>{item}<br/></span>
                })}
            </div>

            const mediaClasses = !this.state.isPdf ? 'media-body col-md-11 col-sm-12' : 'media-body col-12'
            return <li className="media mb-5 row" key={item.id}>
                <div className="col-md-1 col-sm-12">
                    <h5 className="mt-0 mb-1 pb-0" style={{border: 'none'}}>
                        {measure}
                    </h5>
                </div>
                <div className={mediaClasses}>
                    <div className="d-flex w-100 justify-content-between">
                        {title}
                        <span style={{color: 'gray', textAlign: 'right'}}>
                            {price}
                        </span>
                    </div>
                    {shortDescription}
                    {assemblyDetails}
                </div>
            </li>
        })
    }

    render() {
        if (!this.state.receipt) {
            return <div />
        }

        const totals = []
        totals.push(
            <dt className="col-sm-8" key={totals.length}>
                <FormattedMessage
                    id="work_order.receipt.items.work_order_sub_total"
                    defaultMessage="Sub Total"
                />
            </dt>
        )
        totals.push(
            <dd className="col-sm-4" key={totals.length}>
                <FormattedNumber
                    style="currency"
                    currency={this.state.receipt.workOrder.currency}
                    value={this.state.totalAmountWithoutTax}
                />
             </dd>
        )
        for (let i in this.state.receipt.workOrder.taxCalculations) {
            const item = this.state.receipt.workOrder.taxCalculations[i]
            totals.push(
                <dt className="col-sm-8" key={totals.length}>
                    {item.taxName}
                </dt>
            )
            totals.push(
                <dd className="col-sm-4" key={totals.length}>
                    <FormattedNumber
                        style="currency"
                        currency={this.state.receipt.workOrder.currency}
                        value={item.taxAmount}
                    />
                </dd>
            )
        }
        totals.push(
            <dt className="col-sm-8" key={totals.length}>
                <FormattedMessage
                    id="work_order.receipt.items.work_order_total"
                    defaultMessage="Total"
                />
            </dt>
        )
        totals.push(
            <dd className="col-sm-4" key={totals.length}>
                <FormattedNumber
                    style="currency"
                    currency={this.state.receipt.workOrder.currency}
                    value={this.state.totalAmount}
                />
             </dd>
        )

        const containerClass = !this.state.isPdf ? 'col-md-10 col-sm-12 ui-module' : 'col-12'

        let note = this.state.receipt.workOrder.note.split('\n').map((item, key) => {
            return <span key={key}>{item}<br/></span>
        })
        return <div className={containerClass}>
            <div className="row">
                <div className="col-12">
                    <p className="lead">
                        <FormattedMessage
                            id="work_order.receipt.work_order_receipt_title"
                            defaultMessage="Work order receipt"
                        />
                    </p>
                    <div className="row">
                        <p className="col-xl-10 col-lg-8 col-md-8 col-sm-12">
                            <strong>
                                <FormattedMessage
                                    id="work_order.receipt.items.order_reference"
                                    defaultMessage="Order reference"
                                />
                                 :</strong> {this.state.receipt.order.reference}<br/>
                            <strong>
                                <FormattedMessage
                                    id="work_order.receipt.items.work_order_date"
                                    defaultMessage="Date"
                                />
                                :&nbsp;
                            </strong>
                            <FormattedDate
                                    year='numeric'
                                    month='long'
                                    day='numeric'
                                    value={
                                        this.state.receipt.workOrder.completedAt ?
                                        new Date(this.state.receipt.workOrder.completedAt) :
                                        new Date()
                                    }/>
                            <br/>
                            <strong>
                                <FormattedMessage
                                    id="work_order.receipt.items.work_order_started_at"
                                    defaultMessage="Started at"
                                />
                                :&nbsp;
                            </strong>
                            <FormattedTime
                                value={new Date(this.state.receipt.workOrder.startedAt)}/>
                            <br/>
                            <strong>
                                <FormattedMessage
                                    id="work_order.receipt.items.work_order_finished_at"
                                    defaultMessage="Finished at"
                                />
                                :&nbsp;
                            </strong>
                            <FormattedTime
                                value={new Date(this.state.receipt.workOrder.finishedAt)}/>
                            <br/>
                        </p>
                    </div>
                    <hr/>
                </div>

                <div className="col-12">
                    <h3 className="lead">
                        <FormattedMessage
                            id="work_order.receipt.items.summary"
                            defaultMessage="Summary"
                        />
                    </h3>
                    <ul className="list-unstyled mt-4">
                        {this.renderItems()}
                    </ul>
                    <hr/>
                </div>
                <div className="col-12">
                    <dl className="row lead text-right">
                        {totals}
                    </dl>
                    <hr/>
                </div>
                <div className="col-sm-12 col-md-8 col-lg-6">
                    <p>
                        <strong>
                            <FormattedMessage
                                id="work_order.receipt.note_label"
                                defaultMessage="Note"
                            />
                            :
                            <br/>
                        </strong>
                        {note}
                    </p>
                     <p>
                        <strong>
                            <FormattedMessage
                                id="work_order.receipt.signed_by_label"
                                defaultMessage="Signed by"
                            />
                            :&nbsp;
                        </strong>
                        {this.state.receipt.workOrder.signerFirstName + ' ' + this.state.receipt.workOrder.signerLastName}
                        <br/>
                        <strong>
                            <FormattedMessage
                                id="work_order.receipt.items.work_order_date"
                                defaultMessage="Date"
                            />
                            :&nbsp;
                        </strong>
                        <FormattedDate
                            year='numeric'
                            month='long'
                            day='numeric'
                            value={
                                this.state.receipt.workOrder.completedAt ?
                                    new Date(this.state.receipt.workOrder.completedAt) :
                                    new Date()
                            }/>
                        <br/>
                    </p>
                    <p>
                        <img src={this.state.receipt.workOrder.signature} className="w-100 border-bottom border-dark mb-2"/>
                    </p>
                </div>
            </div>
        </div>
    }

}

export default WorkOrderReceiptItems



// WEBPACK FOOTER //
// ./src/workorder/receipt/section/items.component.jsx